import { setDefaultConfig } from 'antd-mobile';
import ar from 'antd-mobile/es/locales/ar-SA';
import en from 'antd-mobile/es/locales/en-US';
import es from 'antd-mobile/es/locales/es-ES';
import tr from 'antd-mobile/es/locales/tr-TR';

import { getAntdLang } from './lang';

export const antdLocales = {
  en,
  ar,
  tr,
  es,
};

export function getAntdLocale(lang: LangType = 'en') {
  return antdLocales[getAntdLang(lang)] ?? antdLocales.en;
}

export function setAntdLocale(lang: LangType = 'en') {
  setDefaultConfig({
    locale: getAntdLocale(lang),
  });
}
